import {Component, OnInit, HostListener, Input } from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CommonHelper} from '../../shared/helpers/CommonHelper';
import {DropDownList} from '../../models/DropDownList.model';
import { Json2csvService } from "../../services/json2csv.service";
import {ToastsManager} from 'ng2-toastr';
import { ErrorHandlerProvider } from '../../shared/providers/errorHandler.provider';
import { kenobyConsultantService } from '../../services/kenobyConsultants.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { LegalCertificateService } from '../../services/legalCertificate.service';
import { LegalCertificate } from '../../models/legalCertificate.model';
import { LegalCertificateSearch } from '../../models/legalCertificate.search.model';
import { LocalStorage } from '../../shared/wrappers/LocalStorage';
import { Responsible } from "../../models/Responsible.model";

@Component({
    selector: 'app-legalCertificate',
    templateUrl: './legalCertificate.component.html',
    styleUrls: ['./legalCertificate.component.scss']
})
export class LegalCertificateComponent implements OnInit {
    @Input() consultantData: any;
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    mask = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
    dropDownResponsable: any;
    objResponsables: any;
    responsibles: Responsible[] = new Array<Responsible>();
    selectedCertificateTypesItems: DropDownList[] = new Array<DropDownList>();
    dropDownListCertificateTypes: DropDownList[] = new Array<DropDownList>();
    dropDownCertificateTypesSettings = {};

    itemsPerPage: number[] = [10, 50, 100];
    totalItems: number = 0;
    currentPage: number = 1;
    totalValue: number;

    legalCertificateForm: FormGroup;
    certificates: LegalCertificate[] = new Array<LegalCertificate>();
    legalCertificateExport: LegalCertificate[] = new Array<LegalCertificate>();
    certificateAux: LegalCertificate = new LegalCertificate();
    commonHelper: CommonHelper = new CommonHelper();
    legalCertificateSearchModel: LegalCertificateSearch = new LegalCertificateSearch();
    loading: boolean;

    constructor(private kenobyConsultantService: kenobyConsultantService,
                private json2csvService: Json2csvService,
                private legalCertificateService: LegalCertificateService,
                private formBuilder: FormBuilder,
                private localStorage: LocalStorage,
                private toastr: ToastsManager,
                private router: Router,
                private userService: UserService,
                private errorHandler: ErrorHandlerProvider) {
    }

   async ngOnInit() {
        this.loading = true;
        this.legalCertificateSearchModel = new LegalCertificateSearch();

        this.responsibles = await this.userService.getAllUsersAsResponsibles();
        this.dropDownResponsable = await this.legalCertificateService.createPropertyObjDropDown(this.responsibles, false, "Titular", "titulares");

        this.dropDownListCertificateTypes = this.commonHelper.getDropDownListItemsEnum(this.commonHelper.getAllCertificateType(), "CertificateType");
        this.dropDownCertificateTypesSettings = this.commonHelper.getDropDownSettings(false, 'Tipos', false, 'Marcar todas os tipos', 'Desmarcar todos os tipos', false,null, '');

        this.legalCertificateForm = this.formBuilder.group({
            name: [null, Validators.required],
            type: [null, [this.validateSelectOption]],
        });

       if(this.localStorage.retrieve("legal-certificates"))
            this.setFilters();

        this.legalCertificateSearchModel.startDate = moment().startOf('month').format('DD/MM/YYYY');
        this.legalCertificateSearchModel.endDate = moment().endOf('month').format('DD/MM/YYYY');

        await this.searchLegalCertificate(1);

        this.closeLoad();
        this.loading = false;
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.keyCode === 13) {
            this.searchLegalCertificate(1);
        }
    }

    async searchLegalCertificate(page?: number, toexport?: boolean) {
        try {
            let limit;
            this.loading = true;
            this.currentPage = page ? page : 1;
            this.legalCertificateSearchModel.skip = (this.currentPage - 1) * this.legalCertificateSearchModel.limit;

            if (toexport) {
                limit = this.legalCertificateSearchModel.limit;
                this.legalCertificateSearchModel.skip = 0;
                delete this.legalCertificateSearchModel.limit;
            }

            this.legalCertificateSearchModel.type = [];
            this.legalCertificateSearchModel.owner = [];

            for (let res of this.dropDownResponsable.selectedItems)
            this.legalCertificateSearchModel.owner.push(res.id);

            for (let d of this.selectedCertificateTypesItems)
                this.legalCertificateSearchModel.type.push(parseInt(d.id));

            if(toexport){
                this.legalCertificateExport = await this.legalCertificateService.searchLegalCertificate(this.legalCertificateSearchModel);
                this.legalCertificateSearchModel.limit = limit;
            } else {
                this.certificates = await this.legalCertificateService.searchLegalCertificate(this.legalCertificateSearchModel);
                this.totalItems = this.legalCertificateSearchModel.totalItems;
                this.totalValue = this.legalCertificateSearchModel.totalValue;

            }

            this.loading = false;
        } catch (error) {
            this.loading = false;
            this.errorHandler.interceptError(error, 'LegalCertificate');
        }
    }


    closeLoad() {
        if ( this.responsibles.length > 0 )
            this.loading = false;
    }

    validateSelectOption(control: AbstractControl) {
        if (control.value == 0 || control.value == '0')
            return {type: true};
        return null;
    }


    async export() {
        await this.searchLegalCertificate(1, true);

        this.json2csvService.export(
            this.legalCertificateExport.map(lgCertificateShow => {
                return {
                    "Nome": lgCertificateShow.name ? lgCertificateShow.name : "-",
                    "Tipo": lgCertificateShow ? this.commonHelper.transcriptCertificateType(lgCertificateShow.type):"-",
                    "Observação": lgCertificateShow.observation ? lgCertificateShow.observation: "-",
                    "Data de Renovação": lgCertificateShow.renovationDate ? moment(lgCertificateShow.renovationDate).format("DD/MM/YYYY") : "-",
                    "Titular": lgCertificateShow.owner ? lgCertificateShow.owner.name : "-",
                    "Qtd de dias de notificação":lgCertificateShow.notificationsDays ? lgCertificateShow.notificationsDays : "-",
                };
            }),
            `Alerta de Documentos Jurídicos- ${new Date().toLocaleDateString('pt-br')}`
        );
    }

    async clear(){
        this.certificateAux = new LegalCertificate();
    }

    verifyDate(date){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.legalCertificateSearchModel.startDate = null;
            this.legalCertificateSearchModel.endDate = null;

        }
    }

    setFilters(){
        let storage = this.localStorage.retrieve("legal-certificates");
        if(storage.legalCertificateSearchModel)
            this.legalCertificateSearchModel = storage.legalCertificateSearchModel;
        this.selectedCertificateTypesItems = storage.selectedCertificateTypesItems?storage.selectedCertificateTypesItems:[];
        this.dropDownResponsable.selectedItems = storage.selectedResponsableItems?storage.selectedResponsableItems:[];
        this.legalCertificateSearchModel.endDate = storage.selectedEndDateItems?storage.selelectedEndDateItems:[];
        this.legalCertificateSearchModel.startDate = storage.selectedStartDateItems?storage.selelectedStartDateItems:[];
    }

    onChange() {
        this.localStorage.persist("legal-certificates", {
            legalCertificateSearchModel: this.legalCertificateSearchModel,
            selectedCertificateTypesItems: this.selectedCertificateTypesItems,
            selectedResponsableItems: this.dropDownResponsable.selectedItems,
            selectedEndDateItems: this.legalCertificateSearchModel.endDate,
            selectedStartDateItems: this.legalCertificateSearchModel.startDate,
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/views/legalCertificate/legalCertificate.component.ts